<template functional>
  <div class="course-overview">
    <div class="course-overview__course-info-wrapper">
      <h6 class="course-overview__branding content-type">
        {{ props.course.track.vendor.title }}
      </h6>
      <h4 class="course-overview__title content-title">
        {{ props.course.title }}
      </h4>
      <p
        v-html="props.course.description"
        class="course-overview__description content-description"
      ></p>
      <component
        :is="injections.components.CourseActivator"
        :course="props.course"
        class="course-overview__activator"
      ></component>
    </div>
    <div class="course-overview__video-contain">
      <div
        v-if="
          props.course.sample_video_id && props.course.sample_video_id !== ''
        "
        class="course-overview__video-wrapper"
      >
        <iframe
          :src="
            `https://www.youtube.com/embed/${props.course.sample_video_id}?autoplay=0&rel=0`
          "
          height="1080"
          width="1920"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import CourseActivator from './CourseActivator.vue'

export default {
  name: 'CourseOverview',
  inject: {
    components: {
      default() {
        return {
          CourseActivator,
        }
      },
    },
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.course-overview {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 0 50px 0;
  @include tablet {
    padding: 0 0 75px 0;
  }
  a {
    color: var(--orange);
    transition: 0.5s all ease;
    border-bottom: 1px solid var(--orange);
    cursor: pointer;
    &:hover {
      color: var(--white);
    }
  }
  &__course-info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding: 0;
    @include tablet {
      width: 50%;
      padding: 0 25px 0 0;
    }
    @include desktop {
      padding: 0 75px 0 0;
    }
    @include lg-desktop {
      padding: 0 100px 0 0;
    }
  }
  &__branding {
    margin: 0;
    font-family: var(--font-medium);
  }
  &__title {
    margin: 10px 0 20px 0;
    font-family: var(--font-bold);
    letter-spacing: -1.04px;
    line-height: 2.7rem;
  }
  &__description {
    margin: 0 0 50px 0;
    font-family: var(--font-medium);
    letter-spacing: -0.36px;
  }
  &__video-contain {
    display: none;
    width: 100%;
    @include tablet {
      display: flex;
      align-items: center;
      padding: 0 0 0 25px;
      width: 50%;
    }
    @include desktop {
      margin: 0;
      padding: 0 0 0 75px;
    }
    @include lg-desktop {
      padding: 0 0 0 100px;
    }
  }
  &__video-wrapper {
    position: relative;
    padding: 25px 0 52.1% 0;
    height: 0;
    width: 100%;
  }
  &__video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
